import axios, { AxiosResponse } from 'axios';
import type { EmptyResponse } from '@/models/index';
import * as utils from '@/apis/apiUtils';
import type {
  HokkaidoAirportMtxsCreateParams,
  HokkaidoAirportMtxGetParams,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportMtxRequest';
import type { HokkaidoAirportMtxResponse } from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportMtxResponse';
import type { HokkaidoAirportMtx } from '@/models/externalReports/hokkaidoAirport/hokkaidoAirportMtx';

export default {
  createHokkaidoAirportMTXs(params: HokkaidoAirportMtxsCreateParams): Promise<AxiosResponse<EmptyResponse>> {
    return axios.post(utils.getApiUrl('/external_reports/hokkaido-airport/mtxs'), params);
  },
  async getMtxsByReportIds(params?: HokkaidoAirportMtxGetParams): Promise<Record<number, HokkaidoAirportMtx[]>> {
    const { data } = await axios.get<HokkaidoAirportMtxResponse[]>(
      utils.getApiUrl('/external_reports/hokkaido-airport/mtxs'),
      {params: params || {}},
    );
    return convertHokkaidoAirportMtxResponseToHokkaidoAirportMtx(data);
  },
};

function convertHokkaidoAirportMtxResponseToHokkaidoAirportMtx(
  hokkaidoAirportMtx: HokkaidoAirportMtxResponse[],
): Record<number, HokkaidoAirportMtx[]> {
  const result: Record<number, HokkaidoAirportMtx[]> = {};
  hokkaidoAirportMtx.forEach(item => {
    const model: HokkaidoAirportMtx = {
      externalReportsHokkaidoAirportCarId: Number(item.external_reports_hokkaido_airport_car_id),
      ts: new Date(item.ts),
      lat: Number(item.lat),
      lon: Number(item.lon),
      status: item.status,
      externalReportsHokkaidoAirportReportId: Number(item.external_reports_hokkaido_airport_report_id),
    };

    if (!result[item.external_reports_hokkaido_airport_report_id]) {
      result[item.external_reports_hokkaido_airport_report_id] = [];
    }
    result[item.external_reports_hokkaido_airport_report_id].push(model);
  });

  return result;
}
